export default __webpack_public_path__ + "static/media/placeholder_private03-en-web.131ca31e.png";